module.exports = __webpack_public_path__ + "img/user-1-active.5c4bea54.png";